import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed5d9f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operation-cover" }
const _hoisted_2 = { class: "middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "top",
      onClick: $setup.switch_menu,
      style: _normalizeStyle($setup.topStyle)
    }, null, 4 /* STYLE */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "left",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.do_left && $setup.do_left(...args)))
      }),
      _createElementVNode("div", {
        class: "right",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.do_right && $setup.do_right(...args)))
      })
    ]),
    _createElementVNode("div", {
      class: "bottom",
      onClick: $setup.switch_footer,
      style: _normalizeStyle($setup.bottomStyle)
    }, null, 4 /* STYLE */)
  ], 512 /* NEED_PATCH */)), [
    [_vShow, $setup.config.enableOperation]
  ])
}